<template>  
    <div class="XR-mobile-groupShop ">
      <div class="title">
        <p class="activeNum">{{pinTuanInfo.FshareTitle}}</p>
        <p class="activeName">{{pinTuanInfo.Fname}}</p>
        <div class="ShopNum" :style="{marginLeft: marginLeft +'px'}">
            <p class="peopleCount">{{totalJoinCount}}人正在拼</p>
              <mu-avatar v-for="(imgItem,index) in pinTuanInfo.FheadPicList" :src="imgItem" class="zindexOne" :key="index" slot="leftAvatar"/>             
          </div>
      </div>
      <div ref="prolist" :class="'pro-list '">
          <div class="groupList" ref="groupList">
            <!-- <template v-for="(pItem,index) in 3">
              <div :class="'item '+ ((index+1)%3==0?'marginright':'')" :style="{width: groupShopItemWidth +'px'}" :key="pItem.SkuId">       
                <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
                  <img :src="pItem.Images&&pItem.Images.length>0? pItem.Images[0].ImgPath:IMGServer_URL+'/images/index-item-default.png'" class="tdnew-pro-img" :style="{imgHeight:groupShopItemWidth+'px'}">
                </router-link>
                 <div class="name">{{pItem.AliasName?pItem.AliasName:pItem.Name}}</div>    
                 <div class="pintuan">拼团</div>
                 <div class="price"> <i class="fa fa-rmb"></i>5445 </div>
              </div>
            </template> -->
              <template v-for="(pItem,index) in pinTuanInfo.Flist">
                <div :class="'item '+ ((index+1)%3==0?'marginright':'')" :style="{width: groupShopItemWidth +'px'}" :key="pItem.FminSkuId">       
                  <router-link :to="'/groupShop/groupProductList?id='+pinTuanInfo.Fid">
                    <img :src="pItem.ImgPath" class="tdnew-pro-img" :style="{width:(groupShopItemWidth-10)+'px',height:(groupShopItemWidth-10)+'px'}">
                  </router-link>
                  <div class="name">{{pItem.ProductName}}</div>    
                  <div class="pintuan">拼团</div>
                  <div class="price"> <i class="fa fa-rmb"></i>{{pItem.FminSkuPrice}}</div>
                </div>
              </template>
              <template v-if="isShowLastDefault" v-for="(morenItem,index) in len" >
                  <div class='item'  :style="{width: groupShopItemWidth +'px'}" :key="index">
                      <img src="/static/index/index-item-default.png" style="display:block; height: 100%;width: 100%;" />
                  </div> 
              </template>            
          </div>
      </div>
    </div>
</template>
<script>
export default {  
  name:'XR-mobile-groupShop',
  data() {
    return {
      groupShopItemWidth: (document.documentElement.clientWidth -17 )/3,
      imgHeight:(document.documentElement.clientWidth -6 )/3-20,
      marginLeft: (document.documentElement.clientWidth-163)/2,
      pinTuanInfo:[],
      isShowLastDefault:false,
      len :0,
      totalJoinCount:0
    }
  },
  props: {
    data : {}
  },
  mounted:function(){    
    this.getPinTuanInfo();
  },
  computed:{
  },
  methods:{
    getPinTuanInfo:function(){
      const ths = this;
      this.$post("/Shop/PinTuanServer/WapGetIndex")
      .then(function(res) {
        if (res.IsSuccess) {          
          ths.pinTuanInfo = res.Data  
          ths.isShowLastDefault = ths.pinTuanInfo.Flist.length ==3?false:true 
          ths.len = 3- ths.pinTuanInfo.Flist.length

          var virtualNum =ths.pinTuanInfo.FvirtualNum
          if(!virtualNum){
            virtualNum = 0
          }else{
            virtualNum = parseInt(virtualNum)
          }
          var realCount = ths.pinTuanInfo.FcountJoinGroup
          if(!realCount){
            realCount = 0
          }else{
            realCount = parseInt(realCount)
          }
          ths.totalJoinCount = virtualNum+realCount
        }
      })
      .catch(function(err) {
        console.log(err);
      });    
    }
  }
}
</script>

<style>
.XR-mobile-groupShop {
  overflow: hidden;
  padding: 5px 0;
  background: url('/static/pintuan.png');
  background-size: 100% 100%;
  margin: 10px 0;
}
.XR-mobile-groupShop .title {
  overflow: hidden;
  padding: 14px 0;
  text-align: center;
}
.XR-mobile-groupShop .title .activeNum {
  text-align: center;
  font-size: 18px;
}
.XR-mobile-groupShop .title .activeName{
  font-size: 22px;
  font-weight: bold;
}
 .XR-mobile-groupShop .title .ShopNum{
    display: flex;
    align-items: center;
    background: #ECA2AD;
    width: 163px;
    padding: 0 5px;
    border-radius: 15px;
    position: relative;
    height: 30px;
    line-height: 30px;
    margin-top: 10px;
  }
  .XR-mobile-groupShop .title .ShopNum .peopleCount{
    font-size: 14px;
    color: #fff;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100px;
  }
  .XR-mobile-groupShop .title .ShopNum .mu-avatar{
    width: 23px;
    height: 23px;
    position: absolute;
    background: #fff;
    border-radius: 50%; 
    top: 3.5px;
  }
  .XR-mobile-groupShop .title .ShopNum .zindexOne{
    right: 5px;
  }
  .XR-mobile-groupShop .title .ShopNum .zindexOne:nth-child(2){
    right: 20px;
  }
  .XR-mobile-groupShop .title .ShopNum .zindexOne:nth-child(3){
    right: 35px;
  }

.XR-mobile-groupShop .listItem{
  float: left;
}
.XR-mobile-groupShop .pro-list {
  overflow: hidden;
}
.XR-mobile-groupShop .pro-list .groupList{ 
  display: flex;
}

.XR-mobile-groupShop .pro-list .item {
  float: left;
  background: white;
  padding: 7px 5px;
  border-radius: 5px 5px;
  margin-left: 4px;
  text-align: center
}
.XR-mobile-groupShop .pro-list .item.marginright {
  margin-right: 4px;
}
.XR-mobile-groupShop .pro-list .item img {
  width: 85px;
  height: 85px;
  object-fit: cover;
}
.XR-mobile-groupShop .pro-list .item .category {
  color: Black;
  padding: 7% 0 0;
  line-height: 20px;
  text-align: center;
}
.XR-mobile-groupShop .pro-list .item .name {
  line-height: 15px;
  margin: 0 0 5%;
  text-align: left;
  font-size: 12px;
  height: 30px;
  overflow: hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2; 
}
.XR-mobile-groupShop .pro-list .item .pintuan{
  font-size: 12px;
  color: #fff;
  background: #EB4D54;
  text-align: center;
  width: 30px;
}
.XR-mobile-groupShop .pro-list .item .price{
  color: #EB4D54;
  text-align: left;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/groupShop/groupShop.vue